import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiEmojiMartOverlayComponent } from './fi-emoji-mart-overlay.component';

@NgModule({
    declarations: [FiEmojiMartOverlayComponent],
    exports: [FiEmojiMartOverlayComponent],
    imports: [CommonModule, PickerModule, MatButtonModule, MatIconModule, FiAppTextSharedModule, FiLoadingModule],
})
export class FiEmojiMartOverlayModule {}
